// extracted by mini-css-extract-plugin
export default {"page":"msp-overview_page__8km0T","container":"msp-overview_container__mxsms"};